import { CALENDLY_URL } from "@/lib/config";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="border-t border-border py-12 md:py-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <a href="#top" data-testid="footer-logo" className="flex items-center gap-2.5">
            <img
              src="https://customer-assets.emergentagent.com/job_autonomous-qa-2/artifacts/n0f1n8e2_Asset%201%403x.jpg"
              alt="Liskov AI"
              className="h-7 w-7 rounded-full object-cover ring-1 ring-border"
            />
            <span className="font-display font-semibold tracking-tight">Liskov AI</span>
            <span className="mono-label text-muted-foreground">/ liskovai.com</span>
          </a>

          <div className="flex items-center gap-6 text-sm text-muted-foreground">
            <a href="#how" className="hover:text-foreground transition-colors">
              How it Works
            </a>
            <a href="#capabilities" className="hover:text-foreground transition-colors">
              Capabilities
            </a>
            <a href="#vision" className="hover:text-foreground transition-colors">
              Vision
            </a>
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-cta-demo"
              className="text-foreground hover:opacity-80 transition-opacity"
            >
              Schedule Demo →
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} Liskov AI · The Autonomous Product Quality Engineer</span>
          <span className="font-mono">v1.0 · Series Stealth</span>
        </div>
      </div>
    </footer>
  );
}
